import {
  GET_COMMUNICATOR,
  // LIST_AVAILABLE_COMMUNICATOR,
  LIST_COMMUNICATOR,
} from "../actions/types";

const initialState = {
  communicator: null,
  communicators: {
    count: 0,
    rows: [],
  },
  // availableCommunicators: [],
};

const communicators = (state = initialState, action) => {
  switch (action.type) {
    case GET_COMMUNICATOR:
      return {
        ...state,
        communicator: action.payload,
        communicators: initialState.communicators,
      };
    case LIST_COMMUNICATOR:
      return {
        ...state,
        communicators: action.payload,
        communicator: initialState.communicator,
      };
    // case LIST_AVAILABLE_COMMUNICATOR:
    //   return {
    //     ...state,
    //     communicators: action.payload,
    //   };
    default:
      return state;
  }
};

export default communicators;
